export const isFullUrl = (url: string): boolean => {
  const regex = /^(http|https):\/\//;
  return regex.test(url);
};
